import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { CustomerInviteEntity } from '@/api/entity_types/CustomerInvite.ts';
import { toast } from 'vue-sonner';

type InviteDataResponse = {
  status: 'success' | 'error',
  message?: string,
  record?: CustomerInviteEntity,
};

export const useInviteDataStore = defineStore('inviteData', () => {
  const inviteData = ref<CustomerInviteEntity | null>(null);

  const setInviteData = (payload: {inviteData: CustomerInviteEntity}) => {
    inviteData.value = payload.inviteData;
  };

  const fetchInviteData = async (payload: {inviteToken: string | null}) => {
    try {
      const response = await fetch(`/api/invitations/${payload.inviteToken}`);
      const data = await response.json() as InviteDataResponse;
      if (data.record) {
        setInviteData({ inviteData: data.record as CustomerInviteEntity });
      } else {
        toast.error('Error', {
          action: { label: 'Dismiss' },
          description: data.message || 'Failed to fetch invite data',
        });
      }
      return data;
    } catch (error: unknown) {
      if (error instanceof Error) {
        return { status: 'error', message: error.message };
      } else {
        return { status: 'error', message: String(error) };
      };
    };
  };

  return {
    inviteData,
    setInviteData,
    fetchInviteData,
  };
});